function getPasswordScore(password) {
  let complexity = 0

  if (hasNumbers(password)) complexity++
  if (hasLowerCaseLetters(password)) complexity++
  if (hasUpperCaseLetters(password)) complexity++
  if (hasNonWords(password)) complexity++

  let score =
    getScoreByUniqueLettersUntil5Repetitions(password) +
    getScoreByComplexity(complexity)

  return parseInt(score)
}

function getScoreByComplexity(complexity) {
  return (complexity - 1) * 10
}

function getScoreByUniqueLettersUntil5Repetitions(password) {
  let score = 0
  let characters = {}
  if (!password) return score

  for (let i = 0; i < password.length; i++) {
    let positionOfCharacter = password[i]
    characters[positionOfCharacter] = (characters[positionOfCharacter] || 0) + 1
    score += 5.0 / characters[positionOfCharacter]
  }

  return score
}

function hasNumbers(password) {
  return /\d/.test(password)
}

function hasLowerCaseLetters(password) {
  return /[a-z]/.test(password)
}

function hasUpperCaseLetters(password) {
  return /[A-Z]/.test(password)
}

function hasNonWords(password) {
  return /\W/.test(password)
}

export default getPasswordScore
